import { useIntl } from "react-intl";
import { DataTableStringColumn } from "~components/DataTable/components/DataTableStringColumn/DataTableStringColumn.tsx";
import type { DataTableColumn } from "~components/DataTable/types/dataTableColumn.ts";
import type { DataTableRow } from "~components/DataTable/types/dataTableRow.ts";
import { useLeaderCriteriaService } from "~pages/LeaderCriteria/hooks/useLeaderCriteriaService.ts";
import { LeaderCriteriaTableColumns } from "~pages/LeaderCriteria/LeaderCriteriaListPage/enums/leaderCriteriaTableColumns.ts";
import type { LeaderCriteria } from "~pages/LeaderCriteria/types/leaderCriteria.ts";
import type { UpdateLeaderCriteriaModel } from "~pages/LeaderCriteria/types/leaderCriteriaModel.ts";

export const useGetLeaderCriteriaTableColumns = (massEditMode: boolean): Array<DataTableColumn<LeaderCriteria>> => {
  const { formatMessage } = useIntl();
  const { updateLeaderCriteria } = useLeaderCriteriaService();

  const updateLeaderCriteriaField = async (
    row: LeaderCriteria & DataTableRow,
    updateData: Omit<UpdateLeaderCriteriaModel, "leaderCriteriaId">,
  ) => {
    row.disabled = true;
    try {
      await updateLeaderCriteria(row.leaderCriteriaId, updateData);
    } finally {
      row.disabled = false;
    }
  };

  return [
    {
      key: LeaderCriteriaTableColumns.Name,
      title: formatMessage({ id: "name" }),
      dataIndex: "name",
      ellipsis: { showTitle: true },
      render: (value: string, row) => (
        <DataTableStringColumn
          value={value}
          isEditMode={massEditMode}
          disabled={row.disabled}
          required
          onSave={(name) => updateLeaderCriteriaField(row, { name })}
        />
      ),
    },
    {
      key: LeaderCriteriaTableColumns.LeaderCriteriaId,
      title: formatMessage({ id: "leaders.qualification.id" }),
      dataIndex: "leaderCriteriaId",
      width: 320,
      copyable: true,
    },
  ];
};
